import { getAddress } from "../api/Login";

const useAuthService = {
  readJwtToken: (key) => {
    const appJwtToken = sessionStorage.getItem("TOKEN");
    if (appJwtToken) {
      const payload = appJwtToken.split(".")[1];
      let jwtObj = JSON.parse(atob(payload));
      return jwtObj[key];
    }
    return "";
  },

  registerEmail: (email) => {
    sessionStorage.setItem("email", email);
  },

  registerAlertShow: () => {
    sessionStorage.setItem("alert", true);
  },

  getName: () => useAuthService.readJwtToken("name"),

  getRole: () => useAuthService.readJwtToken("role"),

  storeIpAddress: (ipAddress) => {
    sessionStorage.setItem("ipAddress", JSON.stringify(ipAddress));
  },


  getUserType: () => useAuthService.readJwtToken("userType"),

  getAuthId: () => useAuthService.readJwtToken("userId"),

  getGroupId: () => useAuthService.readJwtToken("groupId"),

  getHospitalId: () => useAuthService.readJwtToken("hospitalId"),

  getToken: () => {
    let token = "Bearer " + sessionStorage.getItem("TOKEN");
    return token;
  },

  registerToken: (token) => {
    sessionStorage.setItem("TOKEN", token);
  },

  storeAddress: (address) => {
    sessionStorage.setItem("ADDRESS", address);
  },

  storeLatLng: (address) => {
    sessionStorage.setItem("LATLNG", address);
  },

  storeSpeciality: (speciality) => {
    sessionStorage.setItem("SPECIALITY", speciality);
  },

  getAddress:()=>{
    return sessionStorage.getItem("ADDRESS");
  },

  getLatLng:()=>{
    return sessionStorage.getItem("LATLNG");
  },

  getSpeciality:()=>{
    return Number(sessionStorage.getItem("SPECIALITY"));
  },

  isAuth: () => {
    let user = useAuthService.readJwtToken("authUsers");
    return Boolean(user);
  },

  removeAuth: () => {
    console.log("userHas been removed");
    sessionStorage.clear();
  },
};

export default useAuthService;
